/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

 // Generated index.ts file.
export * from './setup-endpoint.service';
export * from './web-query-endpoint.service';
export * from './import-endpoint.service';
export * from './customer-endpoint.service';
export * from './report-endpoint.service';
export * from './off-hire-endpoint.service';
export * from './scaffold-endpoint.service';
export * from './application-for-payment-check-list-endpoint.service';
export * from './contract-endpoint.service';
export * from './timesheet-endpoint.service';
export * from './timesheet-report-endpoint.service';
export * from './stock-report-endpoint.service';
export * from './staff-endpoint.service';
export * from './site-endpoint.service';
export * from './inspection-report-endpoint.service';
export * from './variation-report-endpoint.service';
export * from './configuration-endpoint.service';
export * from './web-command-endpoint.service';
export * from './handover-endpoint.service';
export * from './handover-report-endpoint.service';
export * from './inspection-endpoint.service';
export * from './assets-endpoint.service';
export * from './export-endpoint.service';
export * from './variation-endpoint.service';
export * from './scaffold-report-endpoint.service';
export * from './site-depot-endpoint.service';
